// The stage song actually sounding here — components/city/CityStage writes it,
// scene view reads it. Scene view cuts to the audio you HEAR, not to the clock:
// the element may sit up to 0.8 s off the clock before CityStage re-seeks it,
// and at 120 BPM that is a beat and a half — every cut would land late.
//
// `key` is `${show.a}:${show.t0}:${songIndex}`; `pos` the element's currentTime
// (s) when sampled at `at` (performance.now()).
export const stageAudio = { key: null, pos: 0, at: 0, playing: false, dbg: null };   // dbg: the element's own state (?audiodebug)

// What the street's other sounds give way to (components/city/CitySounds):
// how close a live set is (CityStage — 0..0.85) and whether a conversation is
// being heard nearby (CityTalk). The closest source wins; music never talks over people.
export const cityAudio = { stagePresence: 0, speech: false };

/**
 * Every time the performer speaks into the mic during a set (API Stage.planSet):
 * their opening, their words between songs (2026-10-30), their closing — in
 * the order they are said. [[key, { at, text, audio, dur }], …], `at` = ms from t0.
 */
export function micWords(sh) {
  const out = [];
  if (sh?.open) out.push(['open', sh.open]);
  (Array.isArray(sh?.mids) ? sh.mids : []).forEach((m, i) => { if (m) out.push([`mid${i}`, m]); });
  if (sh?.close) out.push(['close', sh.close]);
  return out;
}

/** The words being said into the mic at `t`, or null. */
export function micWordsAt(sh, t) {
  for (const [, w] of micWords(sh)) {
    const s0 = sh.t0 + (w.at || 0);
    if (w.text && t >= s0 && t < s0 + (Number(w.dur) || 3) * 1000) return w;
  }
  return null;
}

/** Seconds into that song as heard right now, or null when it is not what is playing. */
export function songPosition(key) {
  if (!key || stageAudio.key !== key || !stageAudio.playing) return null;
  const age = performance.now() - stageAudio.at;
  if (age > 1000) return null;
  return stageAudio.pos + age / 1000;
}
